/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileIdeaRequest } from '../../models/profile-idea-request';
import { ProfileIdeaResponse } from '../../models/profile-idea-response';

export interface AddProfileIdea$Params {

/**
 * ID of profile to which will be idea add
 */
  id: number;
  
    /**
     * Profile idea to save.
     */
    body: ProfileIdeaRequest
}

export function addProfileIdea(http: HttpClient, rootUrl: string, params: AddProfileIdea$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileIdeaResponse>> {
  const rb = new RequestBuilder(rootUrl, addProfileIdea.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileIdeaResponse>;
    })
  );
}

addProfileIdea.PATH = '/rest/profile/{id}/idea';
